type LavandaParams = {
  startDate?: string;
  endDate?: string;
  building?: string;
  apartment?: string;
};

export const generateBookingURL = ({
  startDate,
  endDate,
  building,
  apartment,
}: LavandaParams | undefined = {}) => {
  const url = new URL(process.env.NEXT_PUBLIC_LAVANDA_BOOK ?? '');

  if (startDate) url.searchParams.set('from', startDate);
  if (endDate) url.searchParams.set('to', endDate);
  if (building) url.searchParams.set('building_name', building);
  if (apartment) url.searchParams.set('number_of_bedrooms', apartment);

  return url.href;
};
